export default {
	namespaced: true,
	state: {
		selectedImageId: '',
		fullScreen: true,
		gallery: null,
	},
	actions: {
		setFullScreen({ commit }, fs) {
			commit('SET_FULLSCREEN', fs);
		},
		setSelectedImage({ commit }, image) {
			commit('SET_SELECTEDIMAGE', image);
		},
		setGallery({ commit }, gallery) {
			commit('SET_GALLERY', gallery);
		},
	},
	mutations: {
		SET_FULLSCREEN: (state, fs) => {
			if (!fs) {
				state.selectedImageId = '';
			}
			state.fullScreen = fs;
		},
		SET_SELECTEDIMAGE: (state, image) => {
			state.selectedImageId = image;
			state.fullScreen = true;
		},
		SET_GALLERY: (state, gallery) => {
			state.gallery = gallery;
		},
	},
};
